import React from 'react'
import { Cart3Broken } from 'solar-icons'
import { cn } from '@/lib/utils'

import { Hint } from '@/components/ui'

interface OrdersPlaceholderProps {
  className?: string
  title?: string
  description?: string
}

export const OrdersPlaceholder = ({
  className,
  title,
  description,
}: OrdersPlaceholderProps) => {
  return (
    <div
      className={cn(
        'flex h-full min-h-[50svh] w-full flex-col items-center justify-center gap-4 rounded-lg px-20',
        className,
      )}
    >
      <Cart3Broken className="size-20 text-gray-200" strokeWidth={0.6} />
      <div className="flex flex-col items-center gap-2 text-center">
        <span className="text-base font-medium">
          {title ?? 'No saved orders'}
        </span>
        <Hint>
          {description ?? 'Your pending cart orders will appear here.'}
        </Hint>
      </div>
    </div>
  )
}
